import { Dialog, DialogContent, DialogTitle, KbdHint } from '@/components/ui';
import { BINDINGS } from '@/hooks/useKeyboardShortcuts';
import { useUIStore } from '@/stores/uiStore';

export function ShortcutsHelpDialog() {
  const open = useUIStore((s) => s.shortcutsHelpOpen);
  const setOpen = useUIStore((s) => s.setShortcutsHelpOpen);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent>
        <DialogTitle className="mb-3 text-body-lg font-medium text-t1">
          Keyboard shortcuts
        </DialogTitle>
        <ul className="space-y-1.5">
          {BINDINGS.map((b) => (
            <li
              key={b.display + b.description}
              className="flex items-center justify-between gap-3 rounded-md px-2 py-1.5 text-body"
            >
              <span className="text-t1">{b.description}</span>
              <KbdHint>{b.display}</KbdHint>
            </li>
          ))}
        </ul>
      </DialogContent>
    </Dialog>
  );
}
